import { render, staticRenderFns } from "./vconsole.vue?vue&type=template&id=56fdf18f&"
import script from "./vconsole.vue?vue&type=script&lang=js&"
export * from "./vconsole.vue?vue&type=script&lang=js&"
import style0 from "./vconsole.vue?vue&type=style&index=0&lang=scss&module=_&"




function injectStyles (context) {
  
  this["_"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports